export const getTopHolderRank = (dataContext, address) => {
  if (Object.keys(dataContext).length) {
    const rank = dataContext.findIndex(
      ({ address: context }) => context === address
    );
    return rank;
  }
  return "?";
};
